@if (data?.type === 'error') {
<div mat-dialog-title class="markdown-title fw700">
  <h4>{{ data?.title ? data?.title : 'Please try again' }}</h4>
</div>

<mat-dialog-content aria-label="Quotes Error Dialog Content">
  <div>
    <div class="modal-body">
      <div>
        <div class="fs-17 mb-2">
          {{ data?.isSessionExpired ? data?.message : data?.error?.description }}
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" aria-label="Quotes Error Dialog Actions"
  class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  @if (data?.isSessionExpired) {
  <button [id]="id + '_Close'" class="btn btn-primary-link order-2 order-sm-1" (click)="cancelDialog()">Close</button>
  } @else {
  @if (!data?.isQuotesResult) {
  <button [id]="id +  '_UpdateUsage'" class="btn btn-primary order-1 order-sm-2"
    (click)="cancelDialog('updateUsage')">Update usage</button>
  }
  <button [id]="id + '_Cancel'" class="btn btn-primary-link order-2 order-sm-1"
    (click)="data?.isQuotesResult ? navigateToHome() : cancelDialog()">Cancel</button>
  }
</mat-dialog-actions>
}

@if (data?.type === 'retry') {
<mat-dialog-content aria-label="Quotes Error Dialog Content">
  <div>
    <div class="modal-body">
      <div>
        <div class="fs-17 mb-2">
          Please try again to show more tariffs
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" aria-label="Quotes Error Dialog Actions"
  class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  <button [id]="id + '_Retry'" class="btn btn-primary order-1 order-sm-2" (click)="cancelDialog('retry')">Retry</button>
</mat-dialog-actions>
}